<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content" [formEditablePermission]="form">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <h6 *ngIf="isEdit" class="modal-title">Edit Review Automation</h6>
          <h6 *ngIf="!isEdit" class="modal-title">New Review Automation</h6>
          <app-page-help articleId="mHuYHxf3YFQW5LpG4ZPvbC"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <app-form-switch
          *ngIf="isEdit"
          (valueChange)="onTogglePause($event)"
          [formControl]="form.get('status')"
          [disabled]="1 | isReadonlyRole"
          [matTooltip]="(form.get('status').value ? 'Disable' : 'Enable') + ' this automation'"
          matTooltipPosition="above"
          [inline]="true"
        >
          {{ form.get('status').value ? 'Active' : 'Inactive' }}
        </app-form-switch>
        <button
          *ngIf="isEdit"
          (click)="onDelete()"
          [disabled]="1 | isReadonlyRole"
          class="btn btn-secondary-danger"
          type="button"
        >
          <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
        </button>
        <button
          (click)="onSave(form)"
          class="btn btn-secondary-info save-btn"
          type="button"
          *ngIf="tab === tabs.Overview"
          [disabled]="(1 | isReadonlyRole) || (isSaving$ | async)"
        >
          <i class="cs-icon cs-icon-save"></i><ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav drawer-right-navbar" role="tablist" *ngIf="isEdit">
      <li [class.active]="tab === tabs.Overview">
        <a (click)="tab = tabs.Overview" i18n-matTooltip matTooltip="Overview" matTooltipPosition="left">
          <i class="fal fa-bolt"></i>
        </a>
      </li>
      <li [class.active]="tab === tabs.Activity">
        <a (click)="tab = tabs.Activity" i18n-matTooltip matTooltip="Logs" matTooltipPosition="left">
          <i class="cs-icon cs-icon-calendar-clock"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <alert *ngIf="isDuplicate" type="warning">
        <strong i18n>Warning:</strong>
        <ng-container i18n
          >This automation is a duplicate. Please modify the automation details, before clicking</ng-container
        >
        <strong i18n>Save</strong> <ng-container i18n>to create the automation.</ng-container>
      </alert>
      <ng-container [ngSwitch]="tab">
        <ng-container *ngSwitchCase="tabs.Overview">
          <mat-form-field2 class="mat-block">
            <mat-label i18n>Automation Name</mat-label>
            <input
              matInput
              [formControl]="form.get('name')"
              i18n-placeholder
              placeholder="New message name for this automation"
              required
            />
            <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              <ng-container i18n>Name is required</ng-container>
            </mat-error>
          </mat-form-field2>

          <ng-container *ngIf="isEdit">
            <div class="container-box p-3 mb-3">
              <div class="text-uppercase mb-2" i18n>Automation Status</div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Status:</div>
                  <div *ngIf="form.get('status').value" class="text-success text-semi-bold" i18n>Active</div>
                  <div *ngIf="!form.get('status').value" class="text-danger text-semi-bold" i18n>Inactive</div>
                </div>
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Created:</div>
                  <div class="text-semi-bold">{{ automation?.created | epoch }}</div>
                </div>
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Last Triggered:</div>
                  <div class="text-semi-bold">{{ automation?.lastupdate | epoch }}</div>
                </div>
              </div>
            </div>
          </ng-container>

          <div class="flex-fill">
            <div class="step-content">
              <h6 i18n>Send Review After Checkout</h6>
              <ng-template [ngTemplateOutlet]="reviewTime"></ng-template>
              <ng-template [ngTemplateOutlet]="selectChannelRentals"></ng-template>
            </div>

            <div class="step-content mt-3">
              <h6 i18n>Review Templates</h6>
              <ng-template [ngTemplateOutlet]="reviewTemplates"></ng-template>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="tabs.Activity">
          <app-automation-logs [automationGroup]="automation" class="d-block container-box"></app-automation-logs>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #selectChannelRentals>
  <div class="row">
    <div class="col-md-6">
      <mat-form-field2 class="mat-block">
        <app-select
          [items]="channels"
          [formControl]="form.get('channels')"
          bindValue="value"
          bindLabel="name"
          [required]="true"
          [searchable]="true"
          [multiple]="true"
          i18n-placeholder
          placeholder="From these Channels"
          class="mat-block"
        >
        </app-select>
        <mat-error *ngIf="form.get('channels').touched && form.get('channels').hasError('required')">
          <ng-container i18n>Channels is required</ng-container>
        </mat-error>
      </mat-form-field2>
      <div class="alert alert-secondary-info">
        <i class="cs-icon cs-icon-info-circle alert-icon"></i>
        <div class="alert-content text-sm" i18n>All channels will be selected by default if nothing is selected</div>
      </div>
    </div>
    <div class="col-md-6">
      <app-rental-select i18n-placeholder [ctrl]="form.get('rentals')" placeholder="For these Rentals">
      </app-rental-select>

      <div class="alert alert-secondary-info">
        <i class="cs-icon cs-icon-info-circle alert-icon"></i>
        <div class="alert-content text-sm" i18n>All Rentals will be selected by default if nothing is selected</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #reviewTime>
  <div class="row" [formGroup]="timeeventForm">
    <div class="col-md-3">
      <mat-form-field2>
        <input matInput placeholder="Days" formControlName="days" type="number" pattern="^-?(0|[1-9]\d*)?$" required />
        <mat-error *ngIf="timeeventForm.get('days').touched && timeeventForm.get('days').hasError('required')">
          <ng-container i18n>Days are required</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('days').hasError('min')">
          <ng-container i18n>Days need to be at least 0</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('days').hasError('max')">
          <ng-container i18n>Days need to be at most 14</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('days').hasError('pattern')" i18n> Only whole numbers allowed </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-3">
      <mat-form-field2>
        <input
          matInput
          i18n-placeholder
          placeholder="Hours"
          formControlName="hours"
          type="number"
          pattern="^-?(0|[1-9]\d*)?$"
          required
        />
        <mat-error *ngIf="timeeventForm.get('hours').touched && timeeventForm.get('hours').hasError('required')">
          <ng-container i18n>Hours are required</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('hours').hasError('min')">
          <ng-container i18n>Hours need to be at least 4</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('hours').hasError('max')">
          <ng-container i18n>Hours need to be at most 23</ng-container>
        </mat-error>
        <mat-error *ngIf="timeeventForm.get('hours').hasError('pattern')" i18n> Only whole numbers allowed </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-3">
      <div class="form-field-label mb-3" i18n>Default Booking Rating</div>
      <app-rating
        [rating]="form.get('default').value"
        [editable]="true"
        (rate)="form.get('default').setValue($event)"
      ></app-rating>
    </div>
  </div>
</ng-template>

<ng-template #reviewTemplates>
  <div class="row align-items-center mb-3">
    <div class="col-md-6">
      <mat-form-field2 class="mat-block" [showLabel]="false">
        <app-select
          [items]="templates$ | async"
          [formControl]="form.get('templates')"
          bindValue="id"
          bindLabel="name"
          [required]="form.get('templates') | required"
          [searchable]="true"
          [multiple]="true"
          placeholder="Select Templates"
          matTooltip="Choose the templates you want to be sent to guest when the trigger is fired. Template for which rating matches with booking rating will be sent. If there are multiple templates with same rating, template will be chosen randomly."
          i18n-matTooltip
          class="mat-block"
        >
        </app-select>
        <mat-error *ngIf="form.get('templates').touched && form.get('templates').hasError('required')">
          <ng-container i18n>Templates is required</ng-container>
        </mat-error>
      </mat-form-field2>
    </div>
    <div class="col-md-6">
      <button
        (click)="onNewTemplate()"
        class="btn btn-secondary-info mr-3"
        type="button"
        [disabled]="1 | isReadonlyRole"
      >
        <i class="far fa-plus"></i><ng-container i18n>New Template</ng-container>
      </button>
      <app-form-switch
        label="AI Generated Review"
        [formControl]="form.get('ai_enabled')"
        (valueChange)="onToggleAI($event, switch)"
        matTooltip="If this is enabled, review will be generated by Advance AI based to rating assigned in the booking. Templates will be ignored if this is turned ON."
        i18n-matTooltip
        [disabled]="1 | isReadonlyRole"
        [inline]="true"
        #switch
      ></app-form-switch>
    </div>
  </div>
  <div class="table-holder table-responsive" tableContentSize>
    <mat-table #table matSort matSortActive="created" matSortDirection="desc" [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="text-truncate">
            {{ element.subject || element.name }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="body">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <ng-container i18n>Content</ng-container> &nbsp;
          <i
            class="far fa-exclamation-circle"
            matTooltip="This will be sent as public review to Airbnb bookings."
            i18n-matTooltip
          ></i>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div [matTooltip]="element.body | stripHtml" class="text-truncate">
            {{ element.body | stripHtml }}
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="rating">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <ng-container i18n>Rating</ng-container> &nbsp;
          <i
            class="far fa-exclamation-circle"
            matTooltip="Templates will be picked after matching this rating with assigned booking rating."
            i18n-matTooltip
          ></i>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <app-rating [rating]="element.rating || 0"></app-rating>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Action</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a href="javascript:;" (click)="onRemoveTemplate(element)" class="text-danger"
            ><i class="cs-icon cs-icon-trash"></i
          ></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onEditTemplate(row)"
        class="clickable"
      ></mat-row>
    </mat-table>
    <app-empty-table *ngIf="isEmptyTable$ | async" i18n type="ReviewTemplates"> </app-empty-table>

    <mat-paginator2
      #paginator
      [pageSize]="5"
      [class.hidden]="isEmptyTable$ | async"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator2>
  </div>
</ng-template>
